import { KeyboardEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper, Inner, AbsoluteText } from './styles'

interface SwitchDaysProps {
    isChecked: boolean
    handleClick: () => void
    hasDarkMode?: boolean
}

const SwitchDays = ({
    isChecked,
    handleClick,
    hasDarkMode,
}: SwitchDaysProps) => {
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) =>
        event.key === ' ' && handleClick()

    return (
        <Wrapper
            isChecked={isChecked}
            onClick={() => handleClick()}
            onKeyDown={handleKeyDown}
            data-testid="ticket-switch-stay-length"
            hasDarkMode={hasDarkMode}
            tabIndex={0}
        >
            <AbsoluteText
                variant="body"
                hasTransition
                color={
                    !isChecked || hasDarkMode ? 'grayscale_0' : 'grayscale_900'
                }
            >
                <FormattedMessage
                    id="tickets.config.length_switch_day_caption"
                    defaultMessage="1 dzień"
                />
            </AbsoluteText>
            <AbsoluteText
                variant="body"
                hasTransition
                color={
                    isChecked || hasDarkMode ? 'grayscale_0' : 'grayscale_900'
                }
            >
                <FormattedMessage
                    id="tickets.config.length_switch_longer_caption"
                    defaultMessage="Dłużej"
                />
            </AbsoluteText>
            <Inner></Inner>
        </Wrapper>
    )
}

export default SwitchDays
